import navatel from "~/components/icons/navatel.vue"
import metama from "~/components/icons/matama.vue"

const customSvgNameToComponent: any = {
    navatel,
    metama
};

const customIcons = {
    component: (props) => h(customSvgNameToComponent[props.icon]),
};

export { customIcons };